import paths from "./paths";

const section = (label) => ({ id: `section-${label}`, label, section: true });

export const DEFAULT_TOP_NAV = [
  { id: "profile", label: "Profile", to: paths.profile, badge: null },
  { id: "workspaces", label: "Workspaces", to: paths.workspaces, badge: null },
];

export const DEFAULT_BOTTOM_NAV = [
  { id: "settings", label: "Settings", to: paths.settings, badge: null },
  { id: "help-support", label: "Help & Support", to: paths.support, badge: null },
  { id: "legal", label: "Legal and Privacy", to: paths.legalPrivacy, badge: null },
];

export const buildOlreadiaNav = ({
  selectedWorkspace,
  selectedWorkspaceUse = "JOB_SEARCH",
  canManageWorkspace = false,
} = {}) => {
  const workspaceId = selectedWorkspace?.id || "";
  const hasWorkspace = Boolean(workspaceId);
  const isOrganizationWorkspace =
    String(selectedWorkspace?.accountType || "").toUpperCase() === "ORGANIZATION" ||
    Boolean(selectedWorkspace?.organizationId);
  const isJobSearchWorkspace = selectedWorkspaceUse === "JOB_SEARCH";
  const isHiringWorkspace = selectedWorkspaceUse === "HIRING";

  const topNav = [
    // { id: "profile", label: "Profile", to: paths.profile, badge: null },
  ];

  if (hasWorkspace) {
    topNav.push(section(isJobSearchWorkspace ? "My Job Search" : "Jobs & Talent"));

    if (isJobSearchWorkspace) {
      topNav.push(
        { id: "job-search", label: "Job Search", to: paths.jobSearch, badge: null },
        { id: "applications", label: "My Applications", to: paths.jobApplications, badge: null },
        { id: "interviews", label: "Scheduled Interviews", to: paths.interviews, badge: null },
      );
    } else {
      topNav.push(
        { id: "talent-search", label: "Talent Search", to: paths.talentSearch, badge: null },
        { id: "job-posts", label: "Job Posts", to: paths.jobPosts, badge: null },
        { id: "applications", label: "Applications", to: paths.jobApplications, badge: null },
        { id: "interviews", label: "Interviews & Hirings", to: paths.interviews, badge: null },
        { id: "create-job", label: "Create Job", to: paths.newJobPost, badge: null },
      );
    }

    topNav.push(
      {
        id: "professional-profiles",
        label: "Professional Profiles",
        to: paths.professionalProfiles,
        badge: null,
      },
      {
        id: "background-checks",
        label: "Background Checks",
        to: paths.backgroundChecks,
        badge: null,
      },
      { id: "reports", label: "Reports", to: paths.reports, badge: null },
    );
  }

  topNav.push(section("General"));
  topNav.push({ id: "workspaces", label: "Workspaces", to: paths.workspaces, badge: null });

  if (hasWorkspace) {
    // topNav.push({ id: "account-profile", label: "Account Profile", to: paths.profile, badge: null });

    if (isHiringWorkspace && isOrganizationWorkspace) {
      topNav.push({ id: "organizations", label: "Organizations", to: paths.organizations, badge: null });
    }

    topNav.push(
      { id: "invitations", label: "Invitations", to: paths.invitations, badge: null },
      {
        id: "website",
        label: isOrganizationWorkspace ? "Organization Website" : "Personal Website",
        to: paths.website,
        badge: null,
      },
    );
  }

  if (canManageWorkspace) {
    topNav.push({
      id: "access-control",
      label: "Security & Access",
      to: paths.accessControl,
      badge: null,
    });
  }

  topNav.push(
    { id: "settings", label: "Settings", to: paths.settings, badge: null },
    { id: "chat", label: "Chat", to: paths.chatSpace, badge: null },
    { id: "inbox", label: "Inbox", to: paths.emailMessages, badge: null },
    { id: "help-support", label: "Help & Support", to: paths.support, badge: null },
    { id: "feedback", label: "Share Feedback", to: paths.feedback, badge: null },
    { id: "legal", label: "Legal and Privacy", to: paths.legalPrivacy, badge: null },
  );

  const bottomNav = [];

  if (hasWorkspace) {
    bottomNav.push(section("Payments & Plans"));
    bottomNav.push(
      {
        id: "wallet",
        label: "Wallet",
        to: paths.workspacePaymentMethods(workspaceId),
        badge: null,
      },
      {
        id: "charges",
        label: "Charges",
        to: paths.workspaceCharges(workspaceId),
        badge: null,
      },
      {
        id: "subscriptions",
        label: "Subscriptions",
        to: paths.workspaceSubscriptions(workspaceId),
        badge: null,
      },
      { id: "partners", label: "Partnerships", to: paths.partners, badge: null },
    );
  }

  return { topNav, bottomNav };
};

export const TOP_NAV = DEFAULT_TOP_NAV;
export const BOTTOM_NAV = DEFAULT_BOTTOM_NAV;

export const FOOTER_NAV = [
  { id: "settings", label: "Settings", to: paths.settings },
  { id: "help-support", label: "Help & Support", to: paths.support },
];
